export const replaceString = (string, arrWhat = []) => {
  let result = string;
  arrWhat.map((elem) => (result = result.replace(new RegExp(`${elem?.what}`, 'g'), elem.forWhat)));
  return result;
};
